import { useMutatePatientInformations } from './useMutatePatientInformations.hooks'

export const usePatientInformationsSubscribers = () => {
  useMutatePatientInformations()
}
